import * as React from "react";
import { Button, ClickAwayListener, Grow, Paper, Popper, MenuItem, MenuList } from "@material-ui/core";
import MenuIcon from "@material-ui/icons/Menu";
import SettingsIcon from "@material-ui/icons/Settings";
import PeopleOutlineIcon from "@material-ui/icons/PeopleOutline";
import { createStyles, Theme, makeStyles } from "@material-ui/core/styles";
import ListItemIcon from "@material-ui/core/ListItemIcon";
import { useHistory } from "react-router-dom";
import { useSelector } from "react-redux";
import { RootState } from "../../store/rootReducer";
import { BookIcon, CalendarIcon, DashboardIcon, ActivityIconNavBar, SubmitPCRIcon, ViewPCRIcon,WelcomeIcon } from "../../assets/iconComponents/Icons";
import { consts } from "../../common/consts";
import { ArrowDownward, KeyboardArrowDown } from "@material-ui/icons";
import Diamond from "../../assets/icons/shift.png";
const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      display: "flex",
      height: "100%",
    },
    menuButton: {
      justifyContent: "left",
      color: "#fff",
      height: "100%",
      borderRadius: "0px",
      width: 342,
      padding: "6px 20px",
      "&:hover": {
        backgroundColor: "rgba(245, 245, 245, 0.17)",
      },
    },
    menuButtonLabel: {
      whiteSpace: "nowrap",
      overflow: "hidden",
      textOverflow: "ellipsis",
      [theme.breakpoints.only("xs")]: {
        display: "none",
      },
    },
    popper: {
      width: 342,
      marginLeft: -5, //offset transition
      borderRadius: 0,
    },
    paper: {
      backgroundColor: "#02489D",
      color: "#fff",
      borderRadius: 0,
    },
    menuItemIcon: {
      minWidth: 0,
      color: "#fff",
      marginRight: 8,
    },
    menuItem: {
      "&:hover": {
        backgroundColor: "rgba(245, 245, 245, 0.17)",
      },
    },
  })
);

export default function LeftHandMenu() {
  const { authStore } = useSelector((state: RootState) => state);
  const classes = useStyles();
  const [open, setOpen] = React.useState(false);
  const anchorRef = React.useRef<HTMLButtonElement>(null);

  var permissions = authStore.data?.role.split(",");
  const shiftType = authStore.shiftType; 
  const restrictToViewSchedule : boolean = (!permissions?.includes(consts.Permissions.SMADriver) && !permissions?.includes(consts.Permissions.CustomerDriver)) ? false :
  (permissions?.includes(consts.Permissions.SMADriver) || permissions?.includes(consts.Permissions.CustomerDriver)) 
  && shiftType !== 1 ? true : false; 
  const [welcomeMenu, setWelcomeMenu] = React.useState(true);
  const configureWelcomeMenu = () => {
    if(permissions?.includes(consts.Permissions.SMADriver) || permissions?.includes(consts.Permissions.CustomerDriver) || permissions?.includes(consts.Permissions.RequestCallout))
    {
      return false;
    }
    if(permissions){
      if (permissions.length == 1 && ((permissions[0] == consts.Permissions.SMAMakeBooking) || (permissions[0] == consts.Permissions.MakeBooking) || (permissions[0] == ""))) {
        if ((permissions[0] == consts.Permissions.SMAMakeBooking) || (permissions[0] == consts.Permissions.MakeBooking)) {
          return false;
        }
        else{
          return true;
        }
      }
      else if (permissions.length == 1 && ((permissions[0] == consts.Permissions.SMASubmitPatientCareRecords) || (permissions[0] == consts.Permissions.SubmitPatientCareRecord) || (permissions[0] == ""))) {
        if ((permissions[0] == consts.Permissions.SMASubmitPatientCareRecords) || (permissions[0] == consts.Permissions.SubmitPatientCareRecord)) {
          return false;
        }
        else{
          return true;
        }
      }
      else{
        return true;
      }
    }
  };

  const handleToggle = () => {
    setOpen((prevOpen) => !prevOpen);
  };

  const ClearViewPCRlocalStorage = () => {
    localStorage.removeItem("ViewPCR:Keyword");
  };

  const ClearTransferLocalSessions = () => {
    localStorage.removeItem("searchKey");
  }

  const gotoSettings = () => {
    if (authStore?.data?.role?.split(",")?.some((p) => p === consts.Permissions.SMAAdminManageUsers) || authStore?.data?.IsAdmin)
      history.push("/settings/users");
    else if (authStore?.data?.role?.split(",")?.some((p) => p === consts.Permissions.SMAAdminManageLocations)) history.push("/settings/locations");
    else if (authStore?.data?.role?.split(",")?.some((p) => p === consts.Permissions.SMAAdminManageCustomers)) history.push("/settings/customers");
    else if (authStore?.data?.role?.split(",")?.some((p) => p === consts.Permissions.SMAAdminManageReasonsForDelay))
      history.push("/settings/delayReasons");
      else if (authStore?.data?.role?.split(",")?.some((p) => p === consts.Permissions.SMAAdminManageReasonsForDelay))
      history.push("/settings/cancellationReasons");
    else if (authStore?.data?.role?.split(",")?.some((p) => p === consts.Permissions.SMAAdminManageReasonsForDelay))
      history.push("/settings/waitTimeReasons");
    else if (authStore?.data?.role?.split(",")?.some((p) => p === consts.Permissions.SMAAdminManageReasonsForDelay))
      history.push("/settings/calloutReasons");
    else if (authStore?.data?.role?.split(",")?.some((p) => p === consts.Permissions.SMAAdminManageWards)) 
      history.push("/settings/wards");
    else if (authStore?.data?.role?.split(",")?.some((p) => p === consts.Permissions.SMAAdminManageVehicles)) 
      history.push("/settings/vehicles");
  };

  const canAccessSettings = () => {
    return authStore?.data?.role
      ?.split(",")
      ?.some(
        (p) =>
          p === consts.Permissions.SMAAdminManageUsers ||
          p === consts.Permissions.SMAAdminManageCustomers ||
          p === consts.Permissions.SMAAdminManageLocations ||
          p === consts.Permissions.SMAAdminManageWards ||
          p === consts.Permissions.SMAAdminManageReasonsForDelay ||
          p === consts.Permissions.SMAAdminManageVehicles ||
          authStore?.data?.IsAdmin
      );
  };

  const handleClose = (event: React.MouseEvent<EventTarget>) => {
    if (anchorRef.current && anchorRef.current.contains(event.target as HTMLElement)) {
      return;
    }

    setOpen(false);
  };

  function handleListKeyDown(event: React.KeyboardEvent) {
    if (event.key === "Tab") {
      event.preventDefault();
      setOpen(false);
    }
  }

  function getNavbarName() {
    const pathArray = window.location.pathname.toLowerCase().split("/");
    if (window.location.pathname.toLowerCase().endsWith("transferschedule")) {
      return "Patient Transport Schedule";
    } else if (window.location.pathname.toLowerCase().indexOf("settings") >= 0) {
      return "Settings";
    } else if (pathArray.indexOf("transferfulldetails") >= 0) {
      return "Transfers";
    } else if (pathArray.indexOf("transfers") >= 0) {
      return "Transfers";
    } else if (pathArray.indexOf("dashboard") >= 0) {
      return "Reporting";
    } else if (pathArray.indexOf("activities") >= 0) {
      return "Activity";
    } else if (pathArray.indexOf("manageusers") >= 0) {
      return "Manage Users";
    } else if (pathArray.indexOf("managevehicles") >= 0) {
      return "Manage Vehicles";
    } else if (pathArray.indexOf("createuser") >= 0) {
      return "Add User";
    } else if (pathArray.indexOf("agecarecalloutfordriver") >= 0) {
      return "Medical Response Callouts";
    } else if (pathArray.indexOf("agecarecalloutforsma") >= 0) {
      return "Medical Response Callouts";
    } else if (pathArray.indexOf("viewpcr") >= 0) {
        return "View Patient Care Records";
    } else if (pathArray.indexOf("reviewpcr") >= 0) {
        return "Review Patient Care Records";
    } else if (pathArray.indexOf("patientcarerecord") >= 0) {
        return "Submit PCR";       
    }else if (pathArray.indexOf("requestcallout") >= 0) {
      return "Medical Response";
    }else if (pathArray.indexOf("teammembers") >= 0) {
      return "Shift";
    }else if (pathArray.indexOf("eventmedical") >= 0) {
      return "Event Shift";
    }else if (pathArray.indexOf("agecarecalloutfordriver") >= 0) {
      return "Medical Response Callouts";
    }else if (pathArray.indexOf("healthshare") >= 0) {
      return "Healthshare Shift";
    }else if (pathArray.indexOf("healthShare") >= 0) {
      return "Healthshare Shift";
    }else if (pathArray[0]===""&&pathArray[1]==="") {
      return "Welcome";
    }
 
  }
  const headerName = getNavbarName();
  // return focus to the button when we transitioned from !open -> open
//   const prevOpen = React.useRef(open);
//   React.useEffect(() => {
//     if (prevOpen.current === true && open === false) {
//       anchorRef.current!.focus();
//     }
//     prevOpen.current = open;
//   }, [open]);

  const history = useHistory();
  return (
    <div className={classes.root}>
      <Button
        className={classes.menuButton}
        ref={anchorRef}
        aria-controls={open ? "menu-list-grow" : undefined}
        aria-haspopup="true"
        startIcon={headerName !== 'Welcome' ? <MenuIcon style={{ marginRight: 10 }} /> : null}
        onClick={handleToggle}
        endIcon={headerName === 'Welcome' ? <KeyboardArrowDown style={{ marginRight: 10 }}  /> : null}
      >
        <span className={classes.menuButtonLabel}>{headerName}</span>
      </Button>
      <Popper className={classes.popper} open={open} anchorEl={anchorRef.current} role={undefined} transition disablePortal>
        {({ TransitionProps, placement }) => (
          <Grow {...TransitionProps} style={{ transformOrigin: placement === "bottom" ? "center top" : "center bottom" }}>
            <Paper className={classes.paper}>
              <ClickAwayListener onClickAway={handleClose}>
                <MenuList autoFocusItem={open} id="menu-list-grow" onKeyDown={handleListKeyDown}>
                  {
                    configureWelcomeMenu()===true &&
                      (
                        <MenuItem
                          className={classes.menuItem}
                          onClick={() => {
                            history.push("/");
                            handleToggle();
                          }}
                        >
                          <ListItemIcon className={classes.menuItemIcon}>
                            <WelcomeIcon fontSize="small" />
                          </ListItemIcon>
                          Welcome
                        </MenuItem>
                      )
                  } 
                  {authStore?.data?.role
                    ?.split(",")
                    ?.some((p) => p === consts.Permissions.ViewSchedule || p === consts.Permissions.SMAViewSchedule || authStore?.data?.IsAdmin) && !restrictToViewSchedule && (
                    <MenuItem
                      className={classes.menuItem}
                      onClick={() => {
                        history.push("/transferschedule");
                        handleToggle();
                      }}
                    >
                      <ListItemIcon className={classes.menuItemIcon}>
                        <CalendarIcon fontSize="small" />
                      </ListItemIcon>
                      Patient Transport Schedule
                    </MenuItem>
                  )}
                  {(authStore?.data?.role
                    ?.split(",")
                    ?.some(
                      (p) => p === consts.Permissions.SMADriver || p === consts.Permissions.CustomerDriver
                    ) && shiftType === 2 &&
                    <MenuItem
                      className={classes.menuItem}
                      onClick={() => {
                        history.push("/eventMedical/route");
                        handleToggle();
                      }}
                    >
                      <ListItemIcon className={classes.menuItemIcon}>
                      <img  src={Diamond} width={25} alt=""/>
                      </ListItemIcon>
                      Event Shift
                    </MenuItem>
                  )}
                  {(authStore?.data?.role
                    ?.split(",")
                    ?.some(
                      (p) => p === consts.Permissions.SMADriver || p === consts.Permissions.CustomerDriver
                    ) && shiftType === 3 &&
                    <MenuItem
                      className={classes.menuItem}
                      onClick={() => {
                        history.push("/agecarecalloutfordriver");
                        handleToggle();
                      }}
                    >
                      <ListItemIcon className={classes.menuItemIcon}>
                      <img  src={Diamond} width={25} alt=""/>
                      </ListItemIcon>
                      Medical Response Callouts
                    </MenuItem>
                  )}
                  {(authStore?.data?.role
                    ?.split(",")
                    ?.some(
                      (p) => p === consts.Permissions.SMADriver || p === consts.Permissions.CustomerDriver
                    ) && shiftType === 4 &&
                    <MenuItem
                      className={classes.menuItem}
                      onClick={() => {
                        history.push("/healthShare/route");
                        handleToggle();
                      }}
                    >
                      <ListItemIcon className={classes.menuItemIcon}>
                      <img  src={Diamond} width={25} alt=""/>
                      </ListItemIcon>
                      HealthShare Shift
                    </MenuItem>
                  )}
                  {authStore?.data?.role
                    ?.split(",")
                    ?.some(
                      (p) => p === consts.Permissions.SMAManageRequestCallout || p === consts.Permissions.SMASuperUser || authStore?.data?.IsAdmin
                    ) && (
                    <MenuItem
                      className={classes.menuItem}
                      onClick={() => {
                        history.push("/agecarecalloutforsma");
                        handleToggle();
                      }}
                    >
                      <ListItemIcon className={classes.menuItemIcon}>
                        <CalendarIcon fontSize="small" />
                      </ListItemIcon>
                      Medical Response
                    </MenuItem>
                  )}

                  {authStore?.data?.role?.split(",")?.some((p) => p === consts.Permissions.ManageUsers && !authStore?.data?.IsAdmin) && (
                    <MenuItem
                      className={classes.menuItem}
                      onClick={() => {
                        history.push("/manageusers");
                        handleToggle();
                      }}
                    >
                      <ListItemIcon className={classes.menuItemIcon}>
                        <PeopleOutlineIcon fontSize="small" />
                      </ListItemIcon>
                      Manage Users
                    </MenuItem>
                  )}
                  {canAccessSettings() && (
                    <MenuItem
                      className={classes.menuItem}
                      onClick={() => {
                        gotoSettings();
                        handleToggle();
                      }}
                    >
                      <ListItemIcon className={classes.menuItemIcon}>
                        <SettingsIcon fontSize="small" />
                      </ListItemIcon>
                      Settings
                    </MenuItem>
                                  )}

                    {authStore?.data?.role?.split(",")?.some((p) => p === consts.Permissions.ManageCustomerVehicles && !authStore?.data?.IsAdmin) && (
                        <MenuItem
                            className={classes.menuItem}
                            onClick={() => {
                                history.push("/managevehicles");
                                handleToggle();
                            }}
                        >
                            <ListItemIcon className={classes.menuItemIcon}>
                                <SettingsIcon fontSize="small" />
                            </ListItemIcon>
                            Manage Vehicles
                        </MenuItem>
                    )}


                  {authStore?.data?.role?.split(",")?.some((p) => p === consts.Permissions.SMAViewTransferHistory || authStore?.data?.IsAdmin || p === consts.Permissions.ViewCustomerTransferHistory) && (
                    <MenuItem
                      className={classes.menuItem}
                      onClick={() => {
                        history.push("/transfers/0");
                        ClearTransferLocalSessions();
                        handleToggle();
                      }}
                    >
                      <ListItemIcon className={classes.menuItemIcon}>
                        <BookIcon fontSize="small" />
                      </ListItemIcon>
                      Transfers
                    </MenuItem>
                  )}

                  {authStore?.data?.role
                    ?.split(",")
                    ?.some((p) => p === consts.Permissions.SMAAdminViewSystemActivity || authStore?.data?.IsAdmin) && (
                    <MenuItem
                      className={classes.menuItem}
                      onClick={() => {
                        history.push("/activities");
                        handleToggle();
                      }}
                    >
                      <ListItemIcon className={classes.menuItemIcon}>
                        <ActivityIconNavBar fontSize="small" />
                      </ListItemIcon>
                      Activity
                    </MenuItem>
                  )}

                {authStore?.data?.role
                    ?.split(",")
                    ?.some((p) => p === consts.Permissions.ViewPCR || p === consts.Permissions.SMAViewPCR || p === consts.Permissions.SMAViewPatientCareRecords || authStore?.data?.IsAdmin) && (
                    <MenuItem
                      className={classes.menuItem}
                      onClick={() => {
                        history.push("/patientCareRecord/viewpcr/0/false");
                        ClearViewPCRlocalStorage();
                        handleToggle();
                      }}
                    >
                      <ListItemIcon className={classes.menuItemIcon}>
                        <ViewPCRIcon fontSize="small" />
                      </ListItemIcon>
                      Patient Care Records
                    </MenuItem>
                  )}

                  {authStore?.data?.role
                    ?.split(",")
                    ?.some((p) => p === consts.Permissions.SubmitPatientCareRecord || p === consts.Permissions.SMASubmitPatientCareRecords || authStore?.data?.IsAdmin) && (
                    <MenuItem
                      className={classes.menuItem}
                      onClick={() => {
                        history.push("/patientCareRecord");
                        handleToggle();
                      }}
                    >
                      <ListItemIcon className={classes.menuItemIcon}>
                        <SubmitPCRIcon fontSize="small" />
                      </ListItemIcon>
                      Submit PCR
                    </MenuItem>
                  )}
                   {(authStore?.data?.role
                    ?.split(",")
                    ?.some(
                      (p) => p === consts.Permissions.SMADriver || p === consts.Permissions.CustomerDriver
                    ) && shiftType === 1 &&
                    <MenuItem
                      className={classes.menuItem}
                      onClick={() => {
                        localStorage.setItem("TeammemberContinue","Yes")  
                        history.push("/teamMembers");
                        handleToggle();
                      }}
                    >
                      <ListItemIcon className={classes.menuItemIcon}>
                      <img  src={Diamond} width={25} alt=""/>
                      </ListItemIcon>
                      Shift
                    </MenuItem>
                  )}
                  {(authStore?.data?.role
                    ?.split(",")
                    ?.some(
                      (p) => p === consts.Permissions.RequestCallout
                    ) && 
                    // (authStore?.data?.role
                    //   ?.split(",")
                    //   ?.some(
                    //     (p) => p === consts.Permissions.SMADriver || p === consts.Permissions.CustomerDriver
                    //   )) && 
                    <MenuItem
                      className={classes.menuItem}
                      onClick={() => {                    
                        history.push("/requestcallout");
                        handleToggle();
                      }}
                    >
                      <ListItemIcon className={classes.menuItemIcon}>
                      <CalendarIcon fontSize="small" />
                      </ListItemIcon>
                      Medical Response
                    </MenuItem>
                  )}
                  {authStore?.data?.role
                    ?.split(",")
                    ?.some(
                      (p) =>
                        p === consts.Permissions.SMAAdminPatientTransportDashboard ||
                        p === consts.Permissions.ViewDashboard ||
                        authStore?.data?.IsAdmin
                    ) && (
                    <MenuItem
                      className={classes.menuItem}
                      onClick={() => {
                        history.push("/dashboard");
                        handleToggle();
                      }}
                    >
                      <ListItemIcon className={classes.menuItemIcon}>
                        <DashboardIcon fontSize="small" />
                      </ListItemIcon>
                      Reporting
                    </MenuItem>
                  )}
                </MenuList>
              </ClickAwayListener>
            </Paper>
          </Grow>
        )}
      </Popper>
    </div>
  );
}
